import React from 'react'
import './Loading.css'

function Loading() {
  return (
    <div className='spinner-container'>
      
    </div>
  )
}

export default Loading
